/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { Modal, Select } from "@sede-enterprise/shell-ds-react-framework";
import {fetchAlertsFilterData} from "../../../api/alertsApi";
import { filterAlertsLogic, useFilterAlertState, useUpdatedFilterValues } from "./AlertsFilterLogic";
import { alertStatusOptions } from "../../../util/alertStatusOptions"
import { getNextAvailableFilter, getUniqueValues, isAnyFilterSelected, mapAndJoinArray, getAllOptions } from "../../../util/helperFunctions";
import { toast } from "react-toastify";


const AlertsFilterModal = ({ open, onClose, handleFilterChange, handleFilterClear }) => {

  const [noFilter, setNoFilter] = useState(true);

  const [unitOptions, setUnitOptions] = useState([]);
  const [loadingUnit, setLoadingUnit] = useState(false);

  const [siteOptions, setSiteOptions] = useState([]);
  const [loadingSite, setLoadingSite] = useState(false);

  const [equipmentOptions, setEquipmentOptions] = useState([]);
  const [loadingEquipment, setLoadingEquipment] = useState(false);

  const [productionUnitOptions, setProductionUnitOptions] = useState([]);
  const [loadingProductionUnit, setLoadingProductionUnit] = useState(false);

  const [cmlOptions, setcmlOptions] = useState([]);
  const [loadingCml, setLoadingCml] = useState(false);

  const [categoryOptions, setcategoryOptions] = useState([]);
  const [loadingCategory, setLoadingCategory] = useState(false);

  const [cmlEquipmentOptions, setcmlEquipmentOptions] = useState([]);
  const [initialEquipmentOpts, setInitialEquipmentOpts] = useState([]);
  const [initialUnitOpts, setInitialUnitOpts] = useState([]);


  const [filterFormValues, updateFilters] = useFilterAlertState();

  useEffect(() => {

    if (noFilter) {
      setLoadingSite(true);
      setLoadingProductionUnit(true);
      setLoadingUnit(true);
      setLoadingEquipment(true);
      setLoadingCml(true);
      setLoadingCategory(true);

      const fetchData = async () => {
        try{
          const response = await fetchAlertsFilterData(`sensor.excludeFromUi = 0`);
          const { siteOptions, productionUnitOptions, unitOptions, equipmentOptions, cmlOptions } = getAllOptions(response)
          const uniqueStatus = getUniqueValues(response, "status");
          const uniqueCategory = getUniqueValues(response, "category");
          const uniqueEventCode = getUniqueValues(response, "eventCode");
          const allCategoryOptions = [...uniqueCategory, ...uniqueEventCode];

          setSiteOptions(siteOptions);
          setLoadingSite(false);

          setProductionUnitOptions(productionUnitOptions);
          setLoadingProductionUnit(false);
          
          setUnitOptions(unitOptions);
          setLoadingUnit(false);

          setEquipmentOptions(equipmentOptions);
          setLoadingEquipment(false);

          setcmlOptions(cmlOptions);
          setLoadingCml(false);


          setcategoryOptions(allCategoryOptions);
          setLoadingCategory(false)


        } catch (err) {
          toast.error("Cannot fetch filter options");
          //setError(err);
        } finally {
          setNoFilter(false);
        }
    };
    fetchData() 
  }
},[
    setUnitOptions,
    setProductionUnitOptions,
    setEquipmentOptions,
    setSiteOptions,
    setcmlOptions,
    setcategoryOptions,
    noFilter
  ]);



  const improveProdUnit = (data) => {
    const prodUnitOptions = getUniqueValues(data, 'productionUnitName');
    setProductionUnitOptions(prodUnitOptions);
  }

  const improveUnit = (data) => {
      const unitOptions = getUniqueValues(data, 'unitName');
      //console.log(unitOptions)
      setUnitOptions(unitOptions);
  }

  const improveEquipment = (data) => {
      const equipmentOptions = getUniqueValues(data, 'equipmentName');
      setEquipmentOptions(equipmentOptions);
  }

  const improveCml = (data) => {
      const uniqueCML = getUniqueValues(data, 'conditionMonitoringLocationName');
      setcmlOptions(uniqueCML);
  }

  const improveFilter = ({ type, value }) => {
    setNoFilter(false);
    if ([].concat.apply([], Object.values(filterFormValues)).length === 1 && value.length === 0) {
      setNoFilter(true);
      return;
    }
    if (value.length === 0) {
      // If the current filter is empty, get the options based on the next available filter above
      const nextAvailableFilter = getNextAvailableFilter(type, filterFormValues);
      if (nextAvailableFilter) {
        const nextAvailableFilterValue = filterFormValues[nextAvailableFilter];
        improveFilter({ type: nextAvailableFilter, value: nextAvailableFilterValue });
        return;
      }
      setNoFilter(true);
      return;
    }
    if (type === 'unit') {
    
        setLoadingEquipment(true);
        setLoadingCml(true);
        const mapAndJoinArray = (arr) => {
            return arr.map(item => `'${item.value}'`).join(", ");
        };
        fetchAlertsFilterData(`u.shortName IN (${mapAndJoinArray(value)})`).then((data) => {
            if (data && data.length) {
                improveEquipment(data)
                improveCml(data)
            } else {
                setEquipmentOptions([]);
                setcmlOptions([]);
            }
            setLoadingEquipment(false);
            setLoadingCml(false);
        });
    }

    if (type === 'equipment') {
    
      setLoadingCml(true);

        const mapAndJoinArray = (arr) => {
          return arr.map(item => `'${item.value}'`).join(", ");
      };
      fetchAlertsFilterData(`e.shortName IN (${mapAndJoinArray(value)})`).then((data) => {
          if (data && data.length > 0) {
              improveCml(data);
          } else {
              setcmlOptions([]);

          }
          setLoadingCml(false);
      });
  }

    if (type === 'productionUnit') {
        setLoadingUnit(true);
        setLoadingEquipment(true);
        setLoadingCml(true);

          const mapAndJoinArray = (arr) => {
            return arr.map(item => `'${item.value}'`).join(", ");
        };
        fetchAlertsFilterData(`p.shortName IN (${mapAndJoinArray(value)})`).then((data) => {
            if (data && data.length) {
                improveUnit(data)
                improveEquipment(data)
                improveCml(data)
            } else {
                setUnitOptions([]);
                setEquipmentOptions([]);
                setcmlOptions([]);
            }
            setLoadingUnit(false);
            setLoadingEquipment(false);
            setLoadingCml(false);
        });
    }
    if (type === 'site') {
        setLoadingProductionUnit(true);
        setLoadingUnit(true);
        setLoadingEquipment(true);
        setLoadingCml(true);

        
        
        const mapAndJoinArray = (arr) => {
            return arr.map(item => `'${item.value}'`).join(", ");
        };
        fetchAlertsFilterData(`s.shortName IN (${mapAndJoinArray(value)})`).then((data) => {
            
            if (data && data.length > 0) {
                improveUnit(data);
                improveProdUnit(data);
                improveEquipment(data);
                improveCml(data);
            } else {
                setUnitOptions([]);
                setProductionUnitOptions([]);
                setEquipmentOptions([]);
                setcmlOptions([]);
            }
            setLoadingProductionUnit(false);
            setLoadingUnit(false);
            setLoadingEquipment(false);
            setLoadingCml(false);
        });
    }


  }



  const applyInitialFilter = () => {
    Object.keys(filterFormValues).forEach((key) => {
      if (filterFormValues[key].length > 0) {
        improveFilter({ type: key, value: filterFormValues[key] });
      }
    });
  }

  useEffect(() => {
    if (!noFilter) {
      applyInitialFilter();
    }
  }, [noFilter]);

  const getOptionsForFilter = (filter) => {
    switch (filter) {
      case 'site':
        return siteOptions;
      case 'productionUnit':
        return productionUnitOptions;
      case 'unit':
        return unitOptions;
      case 'equipment':
        return equipmentOptions;
      case 'cml':
        return cmlOptions;
      default:
        return [];
    }
  };

  const updatedSiteValues = useUpdatedFilterValues('site', filterFormValues, getOptionsForFilter, updateFilters, noFilter);
  const updatedProdUnitValues = useUpdatedFilterValues('productionUnit', filterFormValues, getOptionsForFilter, updateFilters, noFilter);
  const updatedUnitValues = useUpdatedFilterValues('unit', filterFormValues, getOptionsForFilter, updateFilters, noFilter);
  const updatedEquipmentValues = useUpdatedFilterValues('equipment', filterFormValues, getOptionsForFilter, updateFilters, noFilter);
  const updatedCmlValues = useUpdatedFilterValues('cml', filterFormValues, getOptionsForFilter, updateFilters, noFilter);

  const handleApplyFilter = (e) => {
    const appliedFilter = filterAlertsLogic(filterFormValues);
    handleFilterChange(appliedFilter, filterFormValues)
    onClose();
  };


  const handleOnClear = (e) => {
    handleFilterClear();
    updateFilters({ type: "clear" });
    setNoFilter(true);
    onClose();
  };

  return (
    <>
      <Modal open={open} onClose={() => {
        updateFilters({ type: "clear" });
        onClose();
      }} size='medium' padding='tight' title='Filter Options'
        actions={[
          {
            label: 'Apply',
            action: handleApplyFilter,
            props: {
              disabled: !isAnyFilterSelected(filterFormValues), // disable here
            },
          },
          {
            label: 'Clear All',
            action: handleOnClear,
            props: {
              variant: 'outlined',
            }
          }
        ]}>

        <div className='filter-modal'>
          <Select mode='multiple' placeholder='Select Sites' label='Sites' options={siteOptions}
            showSearch
            filterOption={(input, option) =>
              option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            onChange={(_, option) => {
              updateFilters({ type: 'site', value: option })
              improveFilter({ type: 'site', value: option })
            }}
            loading={loadingSite}
            disabled={loadingSite}
            value={updatedSiteValues}

          />
          <Select mode='multiple' placeholder='Select Prod Units' label='Prod Units' options={productionUnitOptions}
            showSearch
            filterOption={(input, option) =>
              option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            onChange={(_, option) => {
              updateFilters({ type: "productionUnit", value: option })
              improveFilter({ type: "productionUnit", value: option })
            }}
            loading={loadingProductionUnit}
            disabled={loadingProductionUnit}
            value={updatedProdUnitValues}

          />
          <Select mode='multiple' placeholder='Select Units' label='Units' options={unitOptions}
            showSearch
            filterOption={(input, option) =>
              option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            onChange={(_, option) => {
              updateFilters({ type: 'unit', value: option })
              improveFilter({ type: 'unit', value: option })
            }}
            loading={loadingUnit}
            disabled={loadingUnit}
            value={updatedUnitValues}

          />
          <Select mode='multiple' placeholder='Select Equipments' label='Equipments' options={equipmentOptions}
            showSearch
            filterOption={(input, option) =>
              option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            onChange={(_, option) => {
              updateFilters({ type: "equipment", value: option })
              improveFilter({ type: "equipment", value: option })
            }}
            loading={loadingEquipment}
            disabled={loadingEquipment}
            value={updatedEquipmentValues}

          />

          <Select mode='multiple' placeholder='Select CMLs' label='CMLs' options={cmlOptions}
            showSearch
            filterOption={(input, option) =>
              option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            onChange={(_, option) => {
              updateFilters({ type: "cml", value: option })
              improveFilter({ type: "cml", value: option })
            }}
            loading={loadingCml}
            disabled={loadingCml}
            value={updatedCmlValues}

          />
          <Select mode='multiple' placeholder='Select Status' label='Status' options={alertStatusOptions}
            showSearch
            filterOption={(input, option) =>
              option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            onChange={(_, option) => {
              updateFilters({ type: "alertStatus", value: option })
            }}
            value={filterFormValues.alertStatus}
          />
          <Select mode='multiple' placeholder='Select Category' label='Category' options={categoryOptions}
            showSearch
            filterOption={(input, option) =>
              option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            onChange={(_, option) => {
              updateFilters({ type: "category", value: option })
            }}
            value={filterFormValues.category}
            disabled={loadingCategory}
            loading={loadingCategory}
          />
        </div>
      </Modal>
    </>
  );
};

export default AlertsFilterModal;


